import React, {useState} from 'react';
import {useHistory} from 'react-router-dom';

import Header from './Header.js';
import Disclaimers from './Disclaimers.js';
import ConfirmDialog from './ConfirmDialog.js';
import { makeStyles } from '@material-ui/core/styles';

import {psychApps} from './psychApps.js'; // List of psych apps

import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Button from '@material-ui/core/Button';


const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
      padding: 20,
      paddingTop:100,
      margin: 'auto',
      maxWidth: 800,
  },
  card: {
    //padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
      //margin: theme.spacing(2),
      alignItems: 'center',
  },
    button: {
         padding: theme.spacing(2),
      margin: theme.spacing(2),
        alignItems: 'center',
    },
    buttonLog: {
      backgroundColor: "#3d5afe",
      padding: theme.spacing(2),
      margin: theme.spacing(2),
        alignItems: 'center',
    },
    buttonLogSample: {
      backgroundColor: "#3d5afe",
    },
    cardContent: {
        paddingTop: theme.spacing(0),
        paddintBottom: theme.spacing(1),
        paddingRight: theme.spacing(1),
        paddingLeft: theme.spacing(1),
      margin: theme.spacing(0),
    },
    cardAction: {
      justifyContent: 'center',  
       paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(0),
        paddingRight: theme.spacing(1),
        paddingLeft: theme.spacing(1),
      margin: theme.spacing(0),
    },
    cardNews: {
      justifyContent: 'center',  
       paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(1),
        paddingRight: theme.spacing(1),
        paddingLeft: theme.spacing(1),
      margin: theme.spacing(1),
    },
    media: {
        width: 100,
        marginBottom: theme.spacing(2),
    },
}));

export default function MainScreen(props) {
    const classes = useStyles();
    const history = useHistory();
    const [surveyInfoOpen, setSurveyInfoOpen] = useState(false);
    const [logInfoOpen, setLogInfoOpen] = useState(false);

    function handleSurveyInfoClick() {
      setSurveyInfoOpen(true);
    }

    function handleSurveyInfoClose() {
      setSurveyInfoOpen(false);
    }

    function handleLogInfoClick() {
      setLogInfoOpen(true);
    }

    function handleLogInfoClose() {
      setLogInfoOpen(false);
    }

    const showCards = psychApps.map((app)=><Grid item xs={6} key={app.item}>
                <Card className={classes.card} key={app.item}>
                    <CardActions className={classes.cardAction}>
                      {(app.type==="survey") ? 
                        <Button className={classes.button} size="medium" variant="contained" color="primary" value={app.item} onClick={()=>history.push(`/${app.item.toLowerCase()}`)}>{app.title}</Button>
                        :
                        <Button className={classes.buttonLog} size="medium" variant="contained" color="primary" value={app.item} onClick={()=>history.push(`/${app.item.toLowerCase()}`)}>{app.title}</Button>
                      }
  
                    </CardActions>
                    <CardContent className={classes.cardContent} key={app.item}>
                        <Typography variant="subtitle2" color="inherit">{app.subtitle}</Typography>
                    </CardContent>
                </Card>
            </Grid>
        );
    
    return <>
        <div className={classes.root}>
                    <Header title="Psych-Apps" subTitle={<>Easy-to-use psychiatric <Button variant="contained" color="primary" size="small" onClick={handleSurveyInfoClick}>surveys</Button> and <Button className={classes.buttonLogSample} variant="contained" color="primary" size="small" onClick={handleLogInfoClick}>logs</Button> to share with your mental health provider.</>} />
            <br />
            <Grid container spacing={3}>
                {showCards}
            </Grid>
            <Grid container spacing={3}>
            <Grid item xs={12}>
              <Card className={classes.card}>
                  <CardActions className={classes.cardNews}>
                    <Button className={classes.buttonLog} variant="contained" color="primary" size="large" onClick={()=>history.push(`/provider`)}>Tools For Providers</Button>
                  </CardActions>
                  <CardContent className={classes.cardContent}>
                        <Typography variant="subtitle2" color="inherit">Tools and apps targeted to medical and behavioral health providers.</Typography>
                    </CardContent>
                </Card>
              </Grid>
              <Grid item xs={12}>
              <Card className={classes.card}>
                  <CardContent className={classes.cardNews}>
                    <Typography variant="h6" color="secondary">Stay tuned...more apps and surveys to come!</Typography>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
            <Disclaimers/>
        </div>
        <ConfirmDialog title={"Surveys"} description={"Evidenced-based self-report questionnaires used in the aid of diagnosis and track efficacy of treatment. Create PDFs for your records or to share with your providers. Psych-Apps surveys do NOT require logging in for full functionality and data is not stored."} agree="OK" disagree={null} open={surveyInfoOpen} onCloseClick= {null} onAgreeClick={handleSurveyInfoClose}/>
        <ConfirmDialog title={"Logs"} description={"Psych-Apps’ logs help you track certain symptoms and their severity over time.  Create CSV spreadsheet files to share your data with your provider. Google login is required for full functionality of logs—data is stored through Google’s Firebase Firestore database."} agree="OK" disagree={null} open={logInfoOpen} onCloseClick= {null} onAgreeClick={handleLogInfoClose}/>
    </>;
}
